import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GroupIcon from "@mui/icons-material/Group";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const FeaturesList = ({ plan, isPopular }) => {
  const features = [
    {
      icon: <LibraryBooksIcon fontSize="small" />,
      text: `${plan.numberOfLectures}`,
    },
    {
      icon: <AccessTimeIcon fontSize="small" />,
      text: `${plan.duration}`,
    },
    {
      icon: <GroupIcon fontSize="small" />,
      text: `${plan.peopleEnrolled}+ Learners Enrolled`,
    },
    {
      icon: <CalendarMonthIcon fontSize="small" />,
      text: `${plan.validity} ${plan.validityUnit
        .slice(0, 1)
        .toUpperCase()}${plan.validityUnit.slice(1).toLowerCase()} Access`,
    },
    {
      icon: <CodeIcon fontSize="small" />,
      text: `Implement and validate solutions in JAVA, C++, Python, and JavaScript`,
    },
  ];

  return (
    <List disablePadding sx={{ mb: 1 }}>
      {features.map((feature, index) => (
        <ListItem key={index} sx={{ px: 0 }}>
          <ListItemIcon
            sx={{
              minWidth: 32,
              color: isPopular ? "inherit" : "text.secondary",
            }}
          >
            {feature.icon}
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="h5"
                fontWeight="medium"
                sx={{
                  margin: 0,
                }}
              >
                {feature.text}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default FeaturesList;
